import { filesUpload } from "../api";

export const uploadFiles = async (chatId: string, files: File[]): Promise<{ successUrls: string[]; failedFiles: string[] }> => {
    const successUrls: string[] = [];
    const failedFiles: string[] = [];
  
    for (const file of files) {
      const formData = new FormData();
      formData.append("data", file);
      formData.append("chat", chatId);
  
      try {
        const res = await filesUpload(formData);
        if (res.success) {
          successUrls.push(res.result);
        } else {
          failedFiles.push(file.name);
        }
      } catch (err) {
        failedFiles.push(file.name);
      }
    }
  
    return { successUrls, failedFiles };
  };